import React, { useRef, useState } from "react";

export default function ApplyModal({ job }) {
    const editorRef = useRef(null);
    const [coverLetter, setCoverLetter] = useState("");
    const [activeCmds, setActiveCmds] = useState({}); // track active buttons
    const [loading, setLoading] = useState(false);
    if (!job) return null;

    const execCmd = (cmd) => {
        let value = null;

        if (cmd === "createlink") {
            value = prompt("Enter the link here:", "http://");
            if (!value) return;
        }

        document.execCommand(cmd, false, value);
        editorRef.current.focus();

        // state update
        setCoverLetter(editorRef.current.innerHTML);

        // active buttons update
        const isActive = document.queryCommandState(cmd);
        setActiveCmds((prev) => ({ ...prev, [cmd]: isActive }));
    };

    const handleInput = () => {
        setCoverLetter(editorRef.current.innerHTML);

        // har baar check karna padta hai
        const cmds = ["bold", "italic", "underline", "insertOrderedList", "insertUnorderedList"];
        const newActive = {};
        cmds.forEach((c) => {
            newActive[c] = document.queryCommandState(c);
        });
        setActiveCmds(newActive);
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     console.log("Form submitted:");
    //     console.log("Cover Letter:", coverLetter);
    // };
    

    const handleSubmit = async (e) => {
        e.preventDefault();

        const name = document.getElementById("name")?.value.trim();
        const email = document.getElementById("email")?.value.trim();
        const number = document.getElementById("number")?.value.trim();
        const remark = editorRef.current?.innerHTML.trim();
        const resume = document.getElementById("attachment")?.files[0];

        if (!name || !email || !number || !remark || !resume) {
            alert("Please fill in all required fields before submitting.");
            return;
        }

        const formData = new FormData();
        formData.append("name", name);
        formData.append("email_id", email);
        formData.append("mobile_number", number);
        formData.append("remark", remark);
        formData.append("resume", resume);

        try {
            setLoading(true);

            const res = await fetch("https://app.parcelx.in/Api/apply_job", {
                method: "POST",
                body: formData,
            });

            const response = await res.json();
            console.log("API Response:", response);

            if (response.status === "success") {
                e.target.reset();
                editorRef.current.innerHTML = "";

                alert("Form submitted successfully!");

                document.querySelector('[data-bs-dismiss="modal"]')?.click();
            } else {
                alert("Submission failed. Please try again.");
            }

        } catch (err) {
            console.log("Error:", err);
            alert("Failed to submit the form.");
        } finally {
            setLoading(false);
        }
        console.log("Full API response:", formData);
    };
    return (
        <div
            className="modal fade"
            id="exampleModal"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <form onSubmit={handleSubmit}>
                        <div className="modal-header">
                            <h5 className="modal-title">Apply Job: {job.title}</h5>
                            <div className="job-modal">
                                <button type="button" className="close btn-cross" data-bs-dismiss="modal" aria-label="Close" ><span aria-hidden="true">&times;</span></button>
                            </div>
                        </div>

                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label>Name</label>
                                    <input id="name" type="text" className="form-control" placeholder="e.g. Rohit Sharma" />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label>Email</label>
                                    <input id="email" type="email" className="form-control" placeholder="e.g. rohit@gmail.com" />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label>Mobile Number</label>
                                    <input id="number" type="number" max={9999999999} className="form-control" placeholder="e.g. 9876543210" />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label>Upload Resume</label>
                                    <input id="attachment" type="file" className="form-control" accept=".pdf,.docx" />
                                </div>

                                {/* WYSIWYG Editor */}
                                <div className="col-md-12 mb-3">
                                    <label>Cover Letter</label>
                                    <div id="wysiwyg">
                                        <div id="editor" ref={editorRef} contentEditable="true" onInput={handleInput} data-text="Write down your biography here. Let the employers know who you are..."></div>
                                        <div className="btns  mt-2">
                                            <div className="category">
                                                <button type="button" onClick={() => execCmd("bold")} className={`btn-edit ${activeCmds.bold ? "active" : ""}`} >
                                                    <i className="fas fa-bold"></i>
                                                </button>

                                                <button type="button" onClick={() => execCmd("italic")} className={`btn-edit ${activeCmds.italic ? "active" : ""}`} >
                                                    <i className="fas fa-italic"></i>
                                                </button>

                                                <button type="button" onClick={() => execCmd("underline")} className={`btn-edit ${activeCmds.underline ? "active" : ""}`} >
                                                    <i className="fas fa-underline"></i>
                                                </button>

                                                <button type="button" onClick={() => execCmd("insertUnorderedList")} className={`btn-edit ${activeCmds.insertUnorderedList ? "active" : ""}`} >
                                                    <i className="fas fa-list-ul"></i>
                                                </button>

                                                <button type="button" onClick={() => execCmd("insertOrderedList")} className={`btn-edit ${activeCmds.insertOrderedList ? "active" : ""}`} >
                                                    <i className="fas fa-list-ol"></i>
                                                </button>

                                                <button type="button" onClick={() => execCmd("createlink")} className="btn-edit" >
                                                    <i className="fas fa-link"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? "Submitting..." : "Apply Now"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
